import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ContratosService } from 'src/app/services/api-services/contratos-services/contratos.service';
import { formatearFechaCorta } from 'src/app/components/utils/formato-fecha.componente';
import { VerDetallesComponent } from '../ver-detalles/ver-detalles.component';
import { NavigationExtras, Router } from '@angular/router';
import { UserService } from 'src/app/services/api-services/user-services/user.service';


@Component({
  selector: 'app-tabla-contratos',
  templateUrl: './tabla-contratos.component.html',
  styleUrls: ['./tabla-contratos.component.css']
})
export class TablaContratosComponent implements OnInit {

  @Input('data') _pages!: any;
  userData: any;
  userDataAvailable = false;

  selectedContract: any;
  showDescription: boolean = false;

  title: string = "Contratos";
  totalRegisters: any;
  perpage = "10";
  permultiple = "10";
  isLoad = false;
  currentPage: any[] = [];

  searchText = '';
  tempData: any[] = [];


  @ViewChild(VerDetallesComponent, { static: false }) verDetallesComponent!: VerDetallesComponent;

  constructor(
    private readonly contratosService: ContratosService,
    private readonly router: Router,
    private readonly userService: UserService
  ) { }

  ngOnInit(): void {
    // Obtiene los datos del usuario
    this.userService.getUserDataSubject().subscribe((res) => {
      this.userData = res.data;
      this.userDataAvailable = true;
    });
    // Obtiene los datos de la primera página
    this.currentPage = this._pages?.data || [];
    this.totalRegisters = this._pages?.count;
    this.tempData = [...this.currentPage];

  }

  onChangePage(data: any) {
    this.isLoad = true;
    const page = Number(data.CurrentPage) - 1;
    this.contratosService.getContratos(page, Number(this.perpage)).subscribe({
      next: (response) => {
        this.currentPage = response?.data?.data;
        this.totalRegisters = response?.data?.count;
        this.isLoad = false;
      },
      error: (error) => {
        console.error(error);
      },
    });        
    // Reset filters
    this.tempData = [...this.currentPage];
    this.searchText = '';
  }
  // Funcion para darle formato 
  dateformat(date: any) {
    return date != null ? formatearFechaCorta(new Date(date)) : ""
  }


  // ... (existing code)
  // Method to show the contract details in the off-canvas
  showDetails(contract: any) {

    if (contract?.contractEstatusEntity) {
      this.selectedContract = contract;
      return;
    }
    // No se obtienen los datos
    console.log("Error: Contract o contractEstatusEntity es nulo o indefinido.");
  }

  closeOffCanvas() {
    this.selectedContract = null; // Limpiar el contrato seleccionado
  }

  onSearch() {
    const searchValue = this.searchText.trim().toLowerCase();

    if (!searchValue) {
      this.currentPage = [...this.tempData];
      return;
    }

    this.currentPage = this.tempData.filter((contract: any) => {
      // Convertir todas las propiedades del contrato a cadena y buscar en ellas
      const contractString = JSON.stringify(contract).toLowerCase();
      return contractString.includes(searchValue);
    });
  }


  getStatusDescription(statusName: string): string {
    switch (statusName.toLowerCase()) {
      case 'publicado':
        return 'El contrato ya está listo y entró en vigencia';
      case 'vencido':
        return 'la fecha de expiración del contrato se hizo efectiva y no se ha gestionado su renovación o cierre';
      case 'borrador':
        return 'Se creó el proyecto (CW) y se encuentra en proceso de legalización contractual';
      case 'modificacion del borrador':
        return 'El contrato entró en vigencia pero tiene tareas pendientes para publicar';
      case 'congelado':
        return 'Contrato que se encuentra en espera';
      case 'pendiente':
        return 'El contrato está listo y está en espera para inicio de vigencia';
      default:
        return 'Contrato finalizado y en fuera de servicio';
    }
  }



  reloadPage(contractId: number) {
    const navigationExtras: NavigationExtras = {
      // Puedes agregar opciones de navegación aquí si es necesario
    };

    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      return this.router.navigate(['contratos/detallesContrato', contractId], navigationExtras);
    });
  }

  redirectToDetails(contractId: number): void {
    this.router.navigate(['/contratos/detallesContrato', contractId]);
  }

}
